module.exports = __webpack_public_path__ + "static/media/magnifying_glass.08b4d487.svg";